import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { SecuredBaseComponent } from '../base/secured-base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { BroadcastService } from '../services/broadcast.service';
import { PendingPaymentRequestService } from '../services/pending-payment-request.service';
import { PendingPaymentRequest } from '../models/PendingPaymentRequest';
import { FormControl, Validators } from '@angular/forms';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'pending-payment-request',
  templateUrl: 'pending-payment-request.component.html',
  styleUrls: ['pending-payment-request.component.css']
})
export class PendingPaymentRequestComponent extends SecuredBaseComponent {

  amountFormControl = new FormControl('', [Validators.required, Validators.min(0.01)]);

  constructor(public override snackBar: MatSnackBar, public override router: Router, public override managerService: ManagerService,
    private route: ActivatedRoute, private location: Location, private broadcastService: BroadcastService, private pendingPaymentRequestService: PendingPaymentRequestService)
  {
    super(snackBar, router, managerService);
  }

  pendingPaymentRequestId!: string;
  pendingPaymentRequest!: PendingPaymentRequest;

  override ngOnInit() {
    super.ngOnInit();

    this.pendingPaymentRequestId = this.route.snapshot.paramMap.get('id') || '';

    if (this.pendingPaymentRequestId)
      this.loadPendingPaymentRequest();
    else
      this.router.navigate(['/main/pending-payment-requests']);
  }

  loadPendingPaymentRequest() {
    this.pendingPaymentRequestService.get(this.manager.consumerId, this.pendingPaymentRequestId).subscribe(
      result => { this.pendingPaymentRequest = result as PendingPaymentRequest; },
      error => { this.showError(error, 'Get pending payment request has failed due to server error'); }
    );
  }

  formValid() {
    return this.amountFormControl.valid;
  }

  approve() {
    if (this.formValid()) {
      this.pendingPaymentRequestService.approve(this.manager.consumerId, this.pendingPaymentRequest).subscribe(
        () => {
          this.broadcastService.boradcast({ type: this.broadcastService.REFRESH_NOTIFICATIONS });
          this.showSuccess('Successfully approved');
          this.location.back();
        },
        error => { this.showError(error, 'Approve pending payment request has failed due to server error'); }
      );
    }
  }

  cancel() {
    this.location.back();
  }

  back() {
    this.location.back();
  }
}
